// extracted by mini-css-extract-plugin
export default {"flash-click-overlay":"rORbWl","flashClickOverlay":"rORbWl"};